var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7592_53541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13.75H25C25.3315 13.75 25.6495 13.8817 25.8839 14.1161C26.1183 14.3505 26.25 14.6685 26.25 15V15.625C26.25 17.5 23.1038 22.5913 21.25 23.75V25C21.25 25.3315 21.1183 25.6495 20.8839 25.8839C20.6495 26.1183 20.3315 26.25 20 26.25H10C9.66848 26.25 9.35054 26.1183 9.11612 25.8839C8.8817 25.6495 8.75 25.3315 8.75 25V23.75C6.64125 22.4325 3.75 17.5 3.75 15.625V15C3.75 14.6685 3.8817 14.3505 4.11612 14.1161C4.35054 13.8817 4.66848 13.75 5 13.75Z",
    fill: "#E3E6ED",
    stroke: "#C8CEDA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1249 13.75C23.5636 12.4788 23.6574 10.955 23.7499 9.1075V7.5H20.9299C17.3924 7.5 15.1599 8.505 13.8799 10.095",
    stroke: "#C8CEDA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56875 13.76C6.39318 12.9336 6.28656 12.094 6.25 11.25V10H8.44375C9.66875 10 10.695 10.155 11.5425 10.4375",
    stroke: "#C8CEDA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L11.25 5L16.25 8.125",
    stroke: "#C8CEDA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.75V13.125C16.25 12.2962 15.9208 11.5013 15.3347 10.9153C14.7487 10.3292 13.9538 10 13.125 10C12.2962 10 11.5013 10.3292 10.9153 10.9153C10.3292 11.5013 10 12.2962 10 13.125V13.75",
    stroke: "#C8CEDA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7592_53541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoCourse);
export default __webpack_public_path__ + "static/media/icon-no-course.eea181a79ab7e455e6d9d28ff05e616b.svg";
export { ForwardRef as ReactComponent };